import { ActionsDispatcher } from 'store/ActionsDispatcher';
import { WidgetCustomManagedRestOptions } from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import { WidgetRequestResponseByUidManagerBase } from 'widgets/streaming/widgetStreamManager/RequestResponse/WidgetRequestResponseByUidManagerBase';
import IndigoApiError from 'communication/IndigoApiError';

export class WidgetRequestResponseByUidRestManager extends WidgetRequestResponseByUidManagerBase {
    public constructor(private options: WidgetCustomManagedRestOptions) {
        super(
            'WidgetRequestResponseByUidRestManager-' + options.endpointUid,
            options.endpointUid,
            options
        );
    }

    protected callApi(
        dispatcher: ActionsDispatcher,
        payload: unknown
    ): Promise<unknown> {
        return this.options.callApi(
            dispatcher,
            this.options.requestProgressService,
            this.options.indigoServiceClient,
            this.options.dataServices,
            payload
        );
    }

    protected clearRequestData(dispatcher: ActionsDispatcher, key: string) {
        this.options.clearRequestData(dispatcher, key);
    }
    protected handleMessage(
        dispatcher: ActionsDispatcher,
        key: string,
        request: unknown,
        response: unknown
    ) {
        this.options.handleMessage(dispatcher, key, request, response);
    }
    protected handleError(
        dispatcher: ActionsDispatcher,
        key: string,
        request: unknown,
        error: IndigoApiError
    ) {
        this.options.handleError(dispatcher, key, request, error);
    }
    protected removeRequestData(dispatcher: ActionsDispatcher, key: string) {
        this.options.removeRequestData(dispatcher, key);
    }

    public getInfo() {
        return {
            ...super.getInfo(),
            endpointUid: this.options.endpointUid,
        };
    }
}
